import * as types from "./types";
import { combineReducers } from "redux";
import cloneDeep from "lodash/cloneDeep";

function dataSaved(state = { status: false, message: "" }, action) {
  switch (action.type) {
    case types.DATA_SAVED:
      return action.payload;
    case types.RESET_DATA_SAVED:
      return { status: false, message: "" };
    default:
      return state;
  }
}

function listaAlumnos(state = [], { type, payload }) {
  return type === types.ITEM_ADDED
    ? [...cloneDeep(state), cloneDeep(payload)]
    : type === type.ITEM_REMOVED
      ? cloneDeep(state).filter(item => item.id !== payload.id)
      : type === types.RESET
        ? []
        : state;

  // switch (type) {
  //   case types.FETCH:
  //     let data = _.cloneDeep(state);
  //     data.push(payload);
  //     return data;

  //   case types.REMOVED:
  //     let datos = _.cloneDeep(state);
  //     let resp = datos.filter(item => item.id !== payload);
  //     return resp;

  //   case types.RESET:
  //     return [];

  //   default:
  //     return state;
  // }
}

function detalleAlumno(state = {}, action) {
  switch (action.type) {
    case types.FETCH_DETALLE:
      return action.payload;
    case types.RESET_DETALLE:
      return {};
    default:
      return state;
  }
}

const reducer = combineReducers({
  dataSaved,
  listaAlumnos,
  detalleAlumno
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/alumnos/reducers.js